import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShieldCheck, Lock, Database } from "lucide-react";

export default function SystemStatus() {
  const [isHovered, setIsHovered] = useState(false);

  // Hidden on mobile (hidden), visible on desktop (md:flex)
  return (
    <div 
      className="hidden md:flex fixed bottom-6 right-6 z-50 flex-col items-end"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 10, scale: 0.95 }}
            className="mb-3 p-4 rounded-xl bg-[var(--glass-bg)] border border-[var(--glass-border)] backdrop-blur-xl shadow-2xl w-64"
          >
            <div className="space-y-3">
              <div className="flex items-center gap-3 text-xs text-[var(--text-muted)]">
                <Lock size={12} className="text-[var(--nily-teal)]" />
                <span>End-to-End Encryption</span>
              </div>
              <div className="flex items-center gap-3 text-xs text-[var(--text-muted)]">
                <Database size={12} className="text-[var(--nily-teal)]" />
                <span>Zero-Knowledge Storage</span>
              </div>
              <div className="h-px w-full bg-[var(--glass-border)]" />
              <div className="flex justify-between items-center text-[10px] text-[var(--text-muted)] font-mono">
                <span>SESSION ID:</span>
                <span className="text-[var(--nily-teal)]">SECURE-{Math.floor(Math.random() * 9999)}</span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        layout
        className="h-10 pl-3 pr-4 rounded-full bg-[var(--bg-main)]/90 border border-[var(--glass-border)] backdrop-blur-md shadow-lg flex items-center gap-3 hover:border-[var(--nily-teal)]/50 transition-colors"
      >
        <div className="relative flex items-center justify-center w-2 h-2">
          <div className="absolute w-full h-full bg-emerald-500 rounded-full animate-ping opacity-75" />
          <div className="relative w-1.5 h-1.5 bg-emerald-500 rounded-full" />
        </div>
        <div className="flex flex-col items-start leading-none">
          <span className="text-[10px] font-bold text-[var(--text-main)] tracking-wide">SYSTEM OPTIMAL</span>
          <span className="text-[9px] text-[var(--text-muted)]">Privacy Active</span>
        </div>
        <ShieldCheck size={14} className="text-[var(--nily-teal)] ml-1" />
      </motion.button>
    </div>
  );
}
